export default __webpack_public_path__ + "static/media/filter_plus.068fd994.svg";